import React from "react";
import { Menu } from "lucide-react";
import ProfileDropdown from "./ProfileDropdown";
import { useRole } from "contexts/RoleContext";
import { useAuth } from "contexts/AuthContext";

const Header = ({ toggleSidebar }) => {
  const { role } = useRole();
  const { activeProfile, user } = useAuth();

  const firstName =
    activeProfile?.firstname ||
    (activeProfile?.name ? activeProfile.name.split(" ")[0] : null) ||
    user?.firstname ||
    "there";

  const welcome =
    role === "tutor"
      ? { title: `Welcome, ${firstName}! 👋`, subtitle: "Let's make learning impactful 😊" }
      : { title: `Welcome ${firstName}! 👋🏼`, subtitle: "We've got some updates for you." };

  return (
    <header className="flex justify-between items-center bg-white border-b border-neutral_stroke_2 px-4 h-[70px] md:h-[90px] md:px-[4rem]">
      {/* Mobile Menu Button */}
      <button
        onClick={toggleSidebar}
        className="md:hidden text-brand_secondary focus:outline-none shrink-0"
      >
        <Menu size={24} />
      </button>

      {/* Welcome */}
      <div className="flex flex-col min-w-0 mx-3 md:mx-0">
        <h2 className="text-16 md:text-22 font-albra_sans_b text-brand_secondary truncate">
          {welcome.title}
        </h2>
        <p className="hidden md:block text-14 font-aileron_r text-[#4A4A4A] leading-4">
          {welcome.subtitle}
        </p>
      </div>

      {/* User Info */}
      <div className="shrink-0">
        <ProfileDropdown />
      </div>
    </header>
  );
};

export default Header;
